import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/atoms/button';
import useFeatures from 'common/components/hooks/use-features';
import { translate } from 'common/localization';
import { map } from 'underscore';
import styles from 'styles/components/coupon/_coupon-details';

const Detail = ({ points, title }) => (
  <>
    <h2 className={styles.subtitle}>{title}</h2>
    <ul className={styles.termsList}>
      {map(points, point => <li className="coupon-banner__terms-point" key={point}>{point}</li>)}
    </ul>
  </>
);

Detail.propTypes = {
  title: PropTypes.string.isRequired,
  points: PropTypes.array.isRequired,
};

const CouponDetails = ({
  items,
  onClose,
  onStartChat,
  title,
}) => {
  const { lpChatOnCouponBanner } = useFeatures('lpChatOnCouponBanner');

  return (
    <div className={styles.terms}>
      <Button
        aria-label={translate('label.close')}
        className="ui-modal-close-btn"
        id="coupon-banner-terms-close"
        role="button"
        type="button"
        onClick={onClose}
        reset
      />
      <h1 className={styles.title}>{title}</h1>

      {items.map(detail => <Detail key={detail.title} {...detail} />)}

      <p className={styles.contact}>
        {`${translate('label.questions.call')} `}
        <a className={styles.number} href={`tel:+${translate('label.questions.call.number')}`}>
          <strong>{translate('label.questions.call.number')}</strong>
        </a>
        {lpChatOnCouponBanner ?
          <>
            {` ${translate('label.community.or')} `}
            <Button
              className={styles.chat}
              onClick={onStartChat}
              reset
            >
              {translate('label.chat.now')}
            </Button>
          </> : null
        }
      </p>
    </div>
  );
};

CouponDetails.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onStartChat: PropTypes.func.isRequired,
};

export default CouponDetails;
